var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"area-message"},[_c('h5',[_vm._v(_vm._s(_vm.client.full_name))]),(_vm.chat_id)?_c('messages',{attrs:{"chat_id":_vm.chat_id}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }